@if (useFastIconType && item.type !== 'icon') {
    <vn-menu-item
        [item]="item"
        [section]="MenuSection.ProductMenu"
        [displayMode]="MenuDisplayMode.FastIcon"
        badgePosition="FastIcon"
        (onClick)="click()" />
} @else {
    <vn-menu-item [item]="item" [section]="MenuSection.ProductMenu" [displayMode]="MenuDisplayMode.Icon" badgePosition="icon" (onClick)="click()" />
}
